import FormGroup from "../components/FormGroup";
import {InputText} from "primereact/inputtext";
import {useFormik} from "formik";
import {useOutletContext} from "react-router-dom";
import {useEffect, useState} from "react";
import {Calendar} from "primereact/calendar";
import {InputTextarea} from "primereact/inputtextarea";
import {Button} from "primereact/button";
import {classNames} from "primereact/utils";
import formater from "../helpers/formater";
import {DepartmentService} from "../services/DepartmentService";

function DepartmentMain() {

    const context = useOutletContext()
    const [isLoading, setIsLoading] = useState(true)

    const mainForm = useFormik({
        initialValues: {
            name: ''
        },
        validate: (data) => {
            let errors = {}

            if(!data.name){
                errors.name = 'Укажите название филиала'
            }
            if(!data.email){
                errors.email = 'Укажите Email'
            }
            if(!data.phone){
                errors.phone = 'Укажите Телефон'
            }

            return errors
        },
        onSubmit: (data) => {
            setIsLoading(true)
            let params = data

            if(params.worktime_from){
                params.worktime_from = data.worktime_from.getHours() + ':' + data.worktime_from.getMinutes()
            }
            if(params.worktime_to){
                params.worktime_to = data.worktime_to.getHours() + ':' + data.worktime_to.getMinutes()
            }
            if(params.opening_date){
                params.opening_date = formater.dateWithOffset(params.opening_date)
            }
            DepartmentService.update(params.id, params).then((result) => {
                context.updateData()
            })
        }
    })

    useEffect(() => {
        context.setActiveTab('')
        mainForm.setValues(context, false)
        setIsLoading(false)
        if(context.opening_date){
            mainForm.setFieldValue('opening_date', new Date(context.opening_date), false)
        }
        if(context.worktime_from){
            mainForm.setFieldValue('worktime_from', new Date('2001-01-01 ' + context.worktime_from), false)
        }
        if(context.worktime_to){
            mainForm.setFieldValue('worktime_to', new Date('2000-01-01 ' + context.worktime_to), false)
        }
    }, [context]);

    const isFormValid = (name) => !!(mainForm.touched[name] && mainForm.errors[name]);

    return (

        <form className={'edit-department p-b-30'} onSubmit={mainForm.handleSubmit}>

            <div className="row m-b-30">
                <div className="col-lg-4">
                    <div className="card project-list">
                        <div className="card-body">
                            <h3 className={'m-b-30'}>Основное </h3>
                            <FormGroup error={mainForm.errors.name} label={'Наименование филиала'}>
                                <InputText value={mainForm.values.name}  onChange={(e) => mainForm.setFieldValue('name', e.target.value)} className={classNames({'p-invalid': isFormValid('name')})}/>
                            </FormGroup>

                            <FormGroup error={mainForm.errors.address} label={'Адрес'}>
                                <InputText value={mainForm.values.address}  onChange={(e) => mainForm.setFieldValue('address', e.target.value)}/>
                            </FormGroup>

                            <FormGroup error={mainForm.errors.email} label={'Email'}>
                                <InputText value={mainForm.values.email} readOnly={true} onChange={(e) => mainForm.setFieldValue('email', e.target.value)} className={'disabled ' + classNames({'p-invalid': isFormValid('email')})}/>
                            </FormGroup>

                            <FormGroup error={mainForm.errors.phone} label={'Телефон'}>
                                <InputText value={mainForm.values.phone}  onChange={(e) => mainForm.setFieldValue('phone', e.target.value)} className={classNames({'p-invalid': isFormValid('phone')})}/>
                            </FormGroup>

                            <FormGroup error={mainForm.errors.opening_date} label={'Дата открытия'}>
                                <Calendar dateFormat={'dd.mm.yy'} value={mainForm.values.opening_date} icon={'pi pi-calendar'} showIcon={true}  onChange={(e) => mainForm.setFieldValue('opening_date', e.target.value)}/>
                            </FormGroup>

                            <FormGroup error={mainForm.errors.worktime_from} label={'Время работы'} className={''}>
                                <div className="d-flex gap-3 w-100">
                                    <Calendar icon={'pi pi-clock'} showIcon={true} timeOnly={true}
                                              value={mainForm.values.worktime_from}
                                              onChange={(e) => mainForm.setFieldValue('worktime_from', e.value)}/>
                                    <Calendar icon={'pi pi-clock'} showIcon={true} timeOnly={true}
                                              value={mainForm.values.worktime_to}
                                              onChange={(e) => mainForm.setFieldValue('worktime_to', e.value)}/>
                                </div>
                            </FormGroup>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 ">
                    <div className="card project-list">
                        <div className="card-body">
                            <h3 className={'m-b-30'}>Сайт и социальные сети </h3>
                            {/*<hr/>*/}
                            <FormGroup error={mainForm.errors.web} label={'Сайт'}>
                                <InputText value={mainForm.values.web} onChange={(e) => mainForm.setFieldValue('web', e.target.value)}/>
                            </FormGroup>
                            <FormGroup error={mainForm.errors.social_instragram} label={'Instagram'}>
                                <InputText value={mainForm.values.social_instragram} onChange={(e) => mainForm.setFieldValue('social_instragram', e.target.value)}/>
                            </FormGroup>
                            <FormGroup error={mainForm.errors.social_facebook} label={'Facebook'}>
                                <InputText value={mainForm.values.social_facebook} onChange={(e) => mainForm.setFieldValue('social_facebook', e.target.value)}/>
                            </FormGroup>
                            <FormGroup error={mainForm.errors.social_vk} label={'ВКонтакте'}>
                                <InputText value={mainForm.values.social_vk} onChange={(e) => mainForm.setFieldValue('social_vk', e.target.value)}/>
                            </FormGroup>
                            <FormGroup error={mainForm.errors.social_youtube} label={'Youtube'}>
                                <InputText value={mainForm.values.social_youtube}  onChange={(e) => mainForm.setFieldValue('social_youtube', e.target.value)}/>
                            </FormGroup>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 ">
                    <div className="card project-list">
                        <div className="card-body">
                            <h3 className={'m-b-30'}>Данные компании </h3>
                            {/*<hr/>*/}
                            <FormGroup error={mainForm.errors.company_name} label={'Наименование организации'}>
                                <InputText value={mainForm.values.company_name} onChange={(e) => mainForm.setFieldValue('company_name', e.target.value)}/>
                            </FormGroup>
                            <FormGroup error={mainForm.errors.inn} label={'ИНН'}>
                                <InputText value={mainForm.values.inn} onChange={(e) => mainForm.setFieldValue('inn', e.target.value)}/>
                            </FormGroup>
                            <FormGroup error={mainForm.errors.company_address} label={'Адрес регистрации'}>
                                <InputText value={mainForm.values.company_address} onChange={(e) => mainForm.setFieldValue('company_address', e.target.value)}/>
                            </FormGroup>
                            <FormGroup error={mainForm.errors.certificate} label={'Номер св-ва о регистрации юр. лица'}>
                                <InputText value={mainForm.values.certificate} onChange={(e) => mainForm.setFieldValue('certificate', e.target.value)}/>
                            </FormGroup>
                            <FormGroup error={mainForm.errors.responsible_name} label={'ФИО собственника (директора)'}>
                                <InputText value={mainForm.values.responsible_name} onChange={(e) => mainForm.setFieldValue('responsible_name', e.target.value)}/>
                            </FormGroup>
                            <FormGroup error={mainForm.errors.requisite} label={'Реквизиты'}>
                                <InputTextarea autoResize={true} value={mainForm.values.requisite} onChange={(e) => mainForm.setFieldValue('requisite', e.target.value)}/>
                            </FormGroup>

                        </div>
                    </div>
                </div>
            </div>

            <div className="footer footer-fix">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-12">
                            <div className="d-flex justify-content-between">
                                <div></div>
                                <Button type={'submit'} loading={isLoading} label={'Сохранить'} icon={'pi pi-save'} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </form>

    )
}

export default DepartmentMain